import { render, staticRenderFns } from "./PrescriptionToday.vue?vue&type=template&id=3a96ba12&"
import script from "./PrescriptionToday.vue?vue&type=script&lang=js&"
export * from "./PrescriptionToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports